// extracted by mini-css-extract-plugin
module.exports = {"root":"PhoneForm_root__1cpcS","formContainer":"PhoneForm_formContainer__1ODlY","section":"PhoneForm_section__1L8tC"};